<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="车型" prop="mode">
          <el-input
            v-model.trim="form.mode"
            class="fix-width"
            placeholder="请输入车型"
          />
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createCar, updateCar } from '@/api/oa'
import commomFunction from '../common'
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
  name: 'OaCarEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const { branchList, staffList, rateCodeList } = commomFunction()
    const initForm = () => {
      return {
        carId: '',
        title: '',
        text: '',
        step: 1,
        order: 1,
      }
    }
    const form = reactive(initForm())
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
    }
    const showEdit = async (row) => {
      if (row && row.carId) {
        title.value = '修改车辆'
        form.carId = row.carId
        form.title = row.title
        form.mode = row.basic.mode
        form.text = row.basic.text
        form.order = row.basic.order
      } else {
        title.value = '新增车辆'
      }
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form,initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const carId = form.carId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${carId ? '修改' : '新增'}车辆吗`,
            null,
            async () => {
              carId
                ? await updateCar(data)
                : await createCar(data)
              proxy.$baseMessage(
                `${carId ? '修改' : '新增'}车辆成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      branchList,
      formRef,
      form,
      rules,
      dialogFormVisible,
      staffList,
      rateCodeList,
      showEdit,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
